import classNames from 'classnames';
import { Card, CardType, LabelHeader5, LabelTelescope } from '../../components';
import { ThoughtsNegative, ThoughtsPositive } from '../../icons';

type Props = {
    type: 'negative' | 'positive';
    items: string[];
    className?: string;
    children?: React.ReactNode;
};
export function Module1Exercise1ThoughtList({
    type,
    items,
    className,
    children,
}: Props) {
    if (items.length == 0) {
        return null;
    }
    return (
        <Card className={className} type={CardType.Grey}>
            {type == 'negative' ? (
                <>
                    <ThoughtsNegative />
                    <LabelHeader5 class="my-20">
                        Det der presser dig
                    </LabelHeader5>
                </>
            ) : (
                <>
                    <ThoughtsPositive />
                    <LabelHeader5 class="my-20">
                        Det der hjælper dig
                    </LabelHeader5>
                </>
            )}
            {items.map((x, idx) => (
                <LabelTelescope
                    key={idx}
                    className={classNames('mb-10', {
                        'border-t border-t-darker-grey pt-10': idx !== 0,
                    })}
                >
                    {x}
                </LabelTelescope>
            ))}
            {children}
        </Card>
    );
}
